import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const DeleteLocationGroupModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteLocationGroupModalContainer" */
      './DeleteLocationGroupModalContainer'
    ),
  loading: LoadingModal,
});
